var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _vm.inlineMessage.message
        ? _c(
            "v-alert",
            {
              staticClass: "mt-0 mb-3",
              attrs: { type: _vm.inlineMessage.type }
            },
            [_vm._v("\n    " + _vm._s(_vm.inlineMessage.message) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-card",
        { staticClass: "al-view" },
        [
          _c(
            "v-toolbar",
            {
              class: [
                _vm.processing
                  ? "al-view-card-top-color-processing"
                  : "al-view-card-top-color"
              ]
            },
            [
              _c(
                "v-row",
                { attrs: { align: "center" } },
                [
                  _c("v-card-title", [_vm._v("Reset Device Registrations")]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _vm.processing
                    ? _c("v-progress-circular", {
                        staticClass: "mr-3",
                        attrs: {
                          indeterminate: true,
                          rotate: 0,
                          size: 32,
                          width: 4,
                          color: "white"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-form",
            { ref: "form", on: { submit: _vm.onSubmit } },
            [
              _c(
                "v-row",
                { staticClass: "mt-3 mx-0 align-top" },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c(
                        "v-row",
                        { attrs: { dense: "" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  outlined: "",
                                  label: "API Key",
                                  disabled: _vm.processing,
                                  rules: [_vm.rules.required]
                                },
                                model: {
                                  value: _vm.apiKey,
                                  callback: function($$v) {
                                    _vm.apiKey = $$v
                                  },
                                  expression: "apiKey"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  outlined: "",
                                  disabled: _vm.processing,
                                  label: "Serial Number",
                                  rules: [_vm.rules.required]
                                },
                                model: {
                                  value: _vm.serialNumber,
                                  callback: function($$v) {
                                    _vm.serialNumber = $$v
                                  },
                                  expression: "serialNumber"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c(
                        "v-card",
                        { attrs: { flat: "", outlined: "" } },
                        [
                          _c(
                            "v-card-subtitle",
                            { staticStyle: { background: "whitesmoke" } },
                            [_vm._v("Device Details")]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-card-text",
                            { staticClass: "pt-2" },
                            [
                              !_vm.device
                                ? _c(
                                    "v-alert",
                                    { attrs: { type: "info", outlined: "" } },
                                    [_vm._v("Device not loaded.")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !!_vm.device
                                ? _c(
                                    "v-row",
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "al-label",
                                          attrs: { cols: "6", sm: "3" }
                                        },
                                        [_vm._v("Device Type")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "al-value",
                                          attrs: { cols: "6", sm: "9" }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.device.deviceType?.toUpperCase()
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "al-label",
                                          attrs: { cols: "6", sm: "3" }
                                        },
                                        [_vm._v("Registered Property")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "al-value",
                                          attrs: { cols: "6", sm: "9" }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.device.propertyName)
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "al-label",
                                          attrs: { cols: "6", sm: "3" }
                                        },
                                        [_vm._v("Property Owner")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "al-value",
                                          attrs: { cols: "6", sm: "9" }
                                        },
                                        [_vm._v(_vm._s(_vm.device.ownerName))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "al-label",
                                          attrs: { cols: "6", sm: "3" }
                                        },
                                        [_vm._v("Notes")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "al-value",
                                          attrs: { cols: "6", sm: "9" }
                                        },
                                        [_vm._v(_vm._s(_vm.device.notes))]
                                      ),
                                      _vm._v(" "),
                                      !!_vm.device.lastConnectionAttemptTime
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "al-label",
                                              attrs: { cols: "6", sm: "3" }
                                            },
                                            [_vm._v("Last Used")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !!_vm.device.lastConnectionAttemptTime
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "al-value",
                                              attrs: { cols: "6", sm: "9" }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.device
                                                    .lastConnectionAttemptTime
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            { staticClass: "mt-3 px-3" },
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "warning",
                    disabled: _vm.processing || !_vm.device,
                    outlined: ""
                  },
                  on: { click: _vm.clear }
                },
                [_vm._v("Clear")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "primary",
                    outlined: "",
                    disabled: _vm.processing
                  },
                  on: { click: _vm.loadDeviceDetails }
                },
                [_vm._v("Load Device")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "ml-4 mr-4 mb-1",
                  staticStyle: { "font-size": "1.35em" }
                },
                [_vm._v("|")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "primary",
                    disabled: _vm.processing || !_vm.device
                  },
                  on: { click: _vm.resetDeviceRegistrations }
                },
                [_vm._v("\n        Reset Device\n      ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }